import React, { useEffect, useState } from 'react';
import { styles } from './styles';
import { Grid, Button } from '@mui/material';
import { NavigateBefore, NavigateNext, Cancel } from '@mui/icons-material';

export default function Manual({
    idComponent,
    hasBefore,
    hasNext,
    message,
    onNext,
    rect,
    copyConfigurations,
    onFinish,
    padding = 0,
    onBefore,
    divStyles = {
        opacity: 0.5,
        color: "#000",
    } }) {

    const [manualIsActive, setManualIsActive] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            const sidebar = document.getElementById('sidebar');

            if (sidebar) {
                document.addEventListener('keydown', onKeyDown, true);
                document.getElementById('manual-button')
                    .addEventListener('click', () => setManualIsActive(prev => !prev));


                const divMessage = document.getElementById('grid-message-manual');
                divMessage.style.position = 'absolute';

                divMessage.style.width = `${sidebar.getBoundingClientRect().width}px`;
                divMessage.style.height = '90vh';
                divMessage.style.top = '0px';
                divMessage.style.left = '0px';
            }
        }, 100);
    }, []);

    function onKeyDown(event) {
        if (event.keyCode === 27) {//ESC
            close();
        }
    }

    useEffect(() => {
        if (manualIsActive)
            open();
        else
            close();
    }, [manualIsActive]);

    useEffect(() => {
        document.getElementById('manual-elements').innerHTML = '';

        open();
    }, [idComponent]);


    function hasCanvas(element) {
        const children = element.children;
        const quantChilds = children.length;

        for (let i = 0; i < quantChilds; i++) {
            const child = children[i];
            if (child.tagName === 'CANVAS') {
                return child;
            } else {
                const ret = hasCanvas(child);
                if (ret !== false)
                    return ret;
            }
        }

        return false;
    }

    function open() {
        setTimeout(() => {
            const element = document.getElementById(idComponent);

            var pos = element.style.position;
            var top = element.style.top;
            element.style.position = 'relative';
            element.style.top = '-200px';
            element.scrollIntoView({
                behavior: 'instant',
                inline: 'start'
            });
            element.style.top = top;
            element.style.position = pos;

            const copy = copyBoundsElement(element);
            const copiedElement = element.cloneNode(true);
            copy.append(copiedElement);

            if (!!copyConfigurations?.copyCanvas) {
                const canvas = hasCanvas(copiedElement);
                if (canvas !== false) {
                    const originalCanvas = hasCanvas(element);
                    canvas.getContext('2d').drawImage(originalCanvas, 0, 0);
                }
            }

        }, 100);

    }

    function close() {
        document.getElementById('manual-elements').innerHTML = '';
        setManualIsActive(false);
    }

    function copyBoundsElement(element) {
        const copy = document.getElementById('manual-elements');
        copy.innerHTML = '';
        copy.style.backgroundColor = `white`;

        const left = element.getBoundingClientRect().x - (padding / 2) + (rect?.left || 0);
        const top = element.getBoundingClientRect().y - (padding / 2) + (rect?.top || 0);
        const height = element.getBoundingClientRect().height + padding + (rect?.height || 0);
        const width = element.getBoundingClientRect().width + padding + (rect?.width || 0);

        copy.style.height = `${height}px`;
        copy.style.width = `${width}px`;
        copy.style.left = `${left > 0 ? left : 0}px`;
        copy.style.top = `${top > 0 ? top : 0}px`;

        copy.style.padding = `${padding}px`;

        return copy;
    }

    return (
        <div id='manual-root' style={{ display: manualIsActive ? 'block' : 'none' }}>
            <div style={{ ...styles.canvas, zIndex: 9991, borderRadius: '10px' }} id='manual-elements' >
            </div>

            <div id='div-manual' style={{ ...styles.canvas, backgroundColor: divStyles.color, opacity: divStyles.opacity }}>
            </div>

            <Grid
                style={styles.gridMessage}
                container
                alignItems='center'
                justifyContent='center'
                id='grid-message-manual'
            >
                <Grid item>
                    <>
                        <div id='div-message-manual' style={{ zIndex: 9991 }}>
                            {message}
                        </div>

                        <Grid
                            container
                            alignItems='center'
                            justifyContent='center'
                            spacing={1}
                            style={{ marginTop: 5 }}
                        >
                            {
                                hasBefore ?
                                    <Grid item>
                                        <Button onClick={onBefore} variant='outlined' style={styles.controlButton}>
                                            <NavigateBefore style={{ fontSize: 40 }} />
                                        </Button>
                                    </Grid> : false
                            }

                            {
                                hasNext ?
                                    <Grid item>
                                        <Button onClick={onNext} variant='outlined' style={styles.controlButton}>
                                            <NavigateNext style={{ fontSize: 40 }} />
                                        </Button>
                                    </Grid>
                                    :
                                    <Grid item>
                                        <Button
                                            onClick={() => { close(); onFinish() }}
                                            variant='outlined'
                                            style={{ ...styles.controlButton, backgroundColor: '#FD1919' }}
                                        >
                                            <Cancel style={{ fontSize: 30 }} />
                                        </Button>
                                    </Grid>
                            }
                        </Grid>

                    </>
                </Grid>


            </Grid>

        </div>
    );


}
